export const SECTORS_LABEL = "Sectors we serve";

export const SECTORS_LEAD = "We serve";

export const SECTORS: readonly string[] = [
  "Footwear",
  "Apparel",
  "Accessories",
  "Medical",
  "Furniture",
  "Transportation",
  "Home decor",
];

export const SECTORS_MORE = "+ Custom OBJ";
